import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { TrendingUp, TrendingDown, Minus } from "lucide-react";
import { Card } from "@/components/ui/card";

interface MetricRow {
  name: string;
  value: string;
  change?: number;
  trend?: 'up' | 'down' | 'neutral';
  metricType?: 'churn' | 'other';
}

interface MetricsSummaryTableProps {
  metrics: MetricRow[];
}

export function MetricsSummaryTable({ metrics }: MetricsSummaryTableProps) {
  const getTrendIcon = (trend?: 'up' | 'down' | 'neutral') => {
    if (trend === 'up') return <TrendingUp className="h-4 w-4" />;
    if (trend === 'down') return <TrendingDown className="h-4 w-4" />;
    return <Minus className="h-4 w-4" />;
  };

  const getTrendColor = (trend?: 'up' | 'down' | 'neutral', metricType?: 'churn' | 'other') => {
    if (metricType === 'churn') {
      if (trend === 'down') return 'text-success';
      if (trend === 'up') return 'text-destructive';
    } else {
      if (trend === 'up') return 'text-success';
      if (trend === 'down') return 'text-destructive';
    }
    return 'text-muted-foreground';
  };

  return (
    <Card>
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>Métrica</TableHead>
            <TableHead className="text-right">Valor</TableHead>
            <TableHead className="text-right">Variação</TableHead>
            <TableHead className="text-center">Tendência</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {metrics.map((metric, index) => (
            <TableRow key={index}>
              <TableCell className="font-medium">{metric.name}</TableCell>
              <TableCell className="text-right font-semibold">{metric.value}</TableCell>
              <TableCell className="text-right">
                {metric.change !== undefined ? (
                  <span className={getTrendColor(metric.trend, metric.metricType)}>
                    {metric.change > 0 ? '+' : ''}{metric.change.toFixed(1)}%
                  </span>
                ) : (
                  <span className="text-muted-foreground">-</span>
                )}
              </TableCell>
              <TableCell className="text-center">
                <div className={`flex items-center justify-center ${getTrendColor(metric.trend, metric.metricType)}`}>
                  {metric.change !== undefined ? getTrendIcon(metric.trend) : <Minus className="h-4 w-4 text-muted-foreground" />}
                </div>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Card>
  );
}
